import moment from 'moment';
import React, { useRef } from 'react';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Table } from 'semantic-ui-react';
import styled from 'styled-components';
import { PoolTestkitOverviewResponseDto } from 'ts-types/api.types';

const PoolTestkitOverviewContainer = styled.div`
  flex-grow: 1;
  cursor: context-menu;
  overflow: auto;
  max-height: 224px;

  & .ui.table thead tr:first-child > th {
    font-size: 1rem;
    position: sticky !important;
    top: 0;
    z-index: 2;
    background: #fff;
  }

  & .ui.basic.table tbody tr {
    font-size: 1rem;
  }

  & .ui.basic.table tbody tr.pool-member {
    font-weight: bold;
    color: #4183c4;
  }
`;

const StyledHeader = styled.h4`
  & .pool {
    color: #4183c4;
  }
`;

export interface PoolTestkitOverviewProps extends MessageSourceProps {
  poolTestId: number,
  testId: number,
  poolMember: boolean,
  poolTestkitOverviewData: PoolTestkitOverviewResponseDto
}


const PoolTestkitOverview = (props: PoolTestkitOverviewProps) => {

  const myRef = useRef(null);

  const {
    poolTestId,
    testId,
    poolMember,
    poolTestkitOverviewData,
      getMessage
  } = props;

  const {poolTestkitOverview, poolTestkitCode, laboratoryDisplayName} = poolTestkitOverviewData;

  if (myRef) {
    if (myRef.current !== null && myRef.current !== undefined) {
      //@ts-ignore
      const container = myRef.current.getElementsByClassName("pool-testkit-container")[0];
      if (container) {
        const poolMember = container.getElementsByClassName("pool-member");
        if (poolMember.length > 0) {
          const scrollIndex = poolMember[0].getAttribute("id");
          if (scrollIndex > 3) {
            container.getElementsByClassName("pool-member")[0].scrollIntoView();
          }
        }
      }
    }
  }

  const countPooleTestkits = poolTestkitOverview.length;

  return (<div ref={myRef} onClick={evt => {evt.preventDefault(); evt.stopPropagation()}}>
        <StyledHeader>
          {getMessage("patientCentral.overview.row.pooltestKit")}
          &nbsp; (<span className={!poolMember ? "pool" : ""}>#{countPooleTestkits}</span>)
          &nbsp; - &nbsp;
          <span className={!poolMember ? "pool" : ""}>{poolTestkitCode}</span>
          {(laboratoryDisplayName !== null && laboratoryDisplayName !== undefined && laboratoryDisplayName.length > 0)
              &&
            <span className="">&nbsp; : &nbsp; {laboratoryDisplayName}</span>
          }
        </StyledHeader>
        <PoolTestkitOverviewContainer className="pool-testkit-container">
          <Table basic="very" >
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>
                  {getMessage('patientCentral.overview.tableHeader.patientId')}
                </Table.HeaderCell>
                <Table.HeaderCell>
                  {getMessage("patientCentral.overview.tableHeader.patientFirstName")}
                  {getMessage("patientCentral.overview.tableHeader.patientLastName")}
                </Table.HeaderCell>
                <Table.HeaderCell>
                  {getMessage("patientCentral.overview.tableHeader.patientBirthDate")}
                </Table.HeaderCell>
                <Table.HeaderCell>
                  {getMessage('patientCentral.overview.tableHeader.company')}
                </Table.HeaderCell>
                <Table.HeaderCell>
                  {getMessage('patientCentral.overview.tableHeader.testKitCode')}
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            {
              poolTestkitOverview && poolTestkitOverview.length > 0 && (
                  <Table.Body>
                    {
                      poolTestkitOverview.map((pm, index) => {

                        const now = moment();
                        const birthYear  = moment(pm.employeeBirthDate, 'YYYY');

                        // calculates employee's age in years
                        const employeeAge = now.diff(birthYear, 'years');

                        return (
                          <Table.Row key={pm.interventionBookingId}
                                     id={testId === pm.testId ? index : ""}
                                     className={testId === pm.testId ? "pool-member" : ""}>
                            <Table.Cell>{pm.patientId}</Table.Cell>
                            <Table.Cell>{pm.employeeFirstName} {pm.employeeLastName}</Table.Cell>
                            <Table.Cell>
                              {moment(pm.employeeBirthDate).format("DD.MM.YYYY")} ({employeeAge})
                            </Table.Cell>
                            <Table.Cell>{pm.companyDescription}</Table.Cell>
                            <Table.Cell>{pm.testKitCode}</Table.Cell>
                          </Table.Row>
                      )}
                      )
                    }
                  </Table.Body>
              )}
          </Table>
        </PoolTestkitOverviewContainer>
      </div>
  );
};

export default withMessages(PoolTestkitOverview);
